(() => {
  const query = window.matchMedia("(max-width: 600px)");

  function init(root) {
    if (!root || root.dataset.enFv1Ready === "true") return;
    const groups = [...root.querySelectorAll("[data-en-fv1-group]")];
    if (!groups.length) return;

    root.dataset.enFv1Ready = "true";
    const sync = () => {
      const narrow = query.matches;
      groups.forEach((group) => {
        group.open = !narrow;
      });
    };
    sync();
    query.addEventListener("change", sync);

    groups.forEach((group) => {
      group.addEventListener("toggle", () => {
        if (!query.matches || !group.open) return;
        groups.forEach((other) => {
          if (other !== group) other.open = false;
        });
      });
    });
  }

  function initAll(scope = document) {
    if (scope.matches?.("[data-en-fv1]")) init(scope);
    scope.querySelectorAll?.("[data-en-fv1]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll(), { once: true });
  } else {
    initAll();
  }
  document.addEventListener("shopify:section:load", (event) => initAll(event.target));

  /* EN V2 chat launcher control.
     Keep widget available on request even when its floating mobile
     launcher is hidden. Fall back to Contact Us when unavailable. */
  document.addEventListener("click", (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const link = target.closest("[data-en-fv1-open-chat]");
    if (!link) return;

    event.preventDefault();
    const fallback = () => window.location.assign(link.href);

    function waitForGorgias() {
      if (window.GorgiasChat && typeof window.GorgiasChat.init === "function") {
        return Promise.resolve(window.GorgiasChat.init());
      }
      return new Promise((resolve, reject) => {
        let complete = false;
        const onLoaded = () => {
          if (complete) return;
          complete = true;
          clearTimeout(timer);
          resolve();
        };
        const timer = setTimeout(() => {
          if (complete) return;
          complete = true;
          window.removeEventListener("gorgias-widget-loaded", onLoaded);
          reject(new Error("Gorgias chat unavailable"));
        }, 5000);
        window.addEventListener("gorgias-widget-loaded", onLoaded, { once: true });
        if (window.GorgiasChat && typeof window.GorgiasChat.open === "function") onLoaded();
      });
    }

    waitForGorgias().then(() => {
      if (window.GorgiasChat && typeof window.GorgiasChat.open === "function") {
        return window.GorgiasChat.open();
      }
      fallback();
    }).catch(fallback);
  });
})();